import { Routes, Route } from 'react-router-dom';

// Components
import Navigation from './Components/Navigation';
import Footer from './Components/Footer';

import AppLayout from './layouts/AppLayout';

import publicRoutes from './routes/PublicRoutes';
import appRoutes from './routes/AppRoutes';
import adminRoutes from './routes/AdminRoutes';
import mentorRoutes from './routes/MentorRoutes';
import bumdesRoutes from './routes/BumdesRoutes';
import dplRoutes from './routes/DplRoutes';

import { useAuth } from './context/AuthContext';
import ToastNotifications from './Components/ToastNotifications';
import NotFound from './Pages/NotFound';

function App() {
  const { authUser } = useAuth();

  return (
    <>
      <header>
        <Navigation />
      </header>
      <main>
        <Routes>
          <Route path="/" element={<AppLayout />}>
            {publicRoutes(authUser)}
            {appRoutes(authUser)}
          </Route>
          {adminRoutes(authUser)}
          {mentorRoutes()}
          {bumdesRoutes()}
          {dplRoutes()}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <footer>
        <Footer />
      </footer>
      <ToastNotifications />
    </>
  );
}

export default App;
